import React from "react";
import { Result } from "antd";
import CustomButton from "../components/CustomButton";
import { useNavigate } from "react-router-dom";
import { routes } from "../const";

export default function NotFound() {
    const navigate = useNavigate();

    return <Result 
        status="404"
        title="404"
        subTitle="AN ERROR OCCURRED OR PAGE NOT FOUND"
        extra={<CustomButton text="Return to Tasks" onClick={() => navigate(routes.TASK_SELECTION) } />}
    />
}